import AppColors from 'general/constants/AppColors';
import _ from 'lodash';
import PropTypes from 'prop-types';

KTFormGroup.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  inputName: PropTypes.string,
  inputElement: PropTypes.element,
  additionalClassName: PropTypes.string,
  additionalLabelClassName: PropTypes.string,
  labelAdditionalComponent: PropTypes.element,
  isRequired: PropTypes.bool,
  justifyBetween: PropTypes.bool
};

KTFormGroup.defaultProps = {
  label: '',
  inputName: '',
  inputElement: <></>,
  additionalClassName: '',
  additionalLabelClassName: '',
  labelAdditionalComponent: null,
  isRequired: false,
  justifyBetween: true
};

/**
 *
 * @param {{
 * label: string|element,
 * inputName: string,
 * inputElement: element,
 * additionalClassName: string,
 * additionalLabelClassName: string,
 * labelAdditionalComponent: element,
 * isRequired: boolean,
 * justifyBetween: boolean
 * }} props
 * @returns
 */
function KTFormGroup(props) {
  // MARK: --- Params ---
  const {
    label,
    inputName,
    inputElement,
    additionalClassName,
    additionalLabelClassName,
    labelAdditionalComponent,
    isRequired,
    justifyBetween
  } = props;

  return (
    <div className={`form-group ${additionalClassName}`}>
      <div className={`d-flex ${justifyBetween ? 'justify-content-between' : ''}`}>
        {!_.isEmpty(label) && (
          <label htmlFor={inputName} className={`${additionalLabelClassName}`}>
            {label} {isRequired && <span style={{ color: AppColors.danger }}>*</span>}
          </label>
        )}
        {!_.isNull(labelAdditionalComponent) && labelAdditionalComponent}
      </div>
      {inputElement}
    </div>
  );
}

export default KTFormGroup;
